import ModeIndicator from 'automation-ui-canvas/containers/enrollment-history/utils/ModeIndicator';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import { useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import LazyLangLoaderDecorator from 'automation-ui-i18n/LazyLangLoaderDecorator';
import actionFeaturesTranslations from 'i2l?query=sporks!automation-ui-canvas/lang/action-features/en.lyaml';
import FlowViewSimpleCanvas from 'automation-ui-canvas/containers/flow-views/FlowViewSimpleCanvas';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FlowViewCanvas = props => {
  var _config$modeIndicator2;
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  /* eslint-disable react/prop-types */
  const {
    canvasScrollElementRef,
    config
  } = props;
  const InternalCanvasComponent = useCallback(canvasProps => {
    return /*#__PURE__*/_jsx(FlowViewSimpleCanvas, Object.assign({
      flowId: props.flow.flowId,
      canvasScrollElementRef: canvasScrollElementRef
    }, canvasProps));
  }, [canvasScrollElementRef, props.flow.flowId]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [config.modeIndicator && /*#__PURE__*/_jsx(ModeIndicator, {
      use: config.modeIndicator.use,
      onCancel: () => {
        var _config$modeIndicator;
        if (config !== null && config !== void 0 && (_config$modeIndicator = config.modeIndicator) !== null && _config$modeIndicator !== void 0 && _config$modeIndicator.ConfirmModal) {
          setShowConfirmModal(true);
        } else {
          props.onCancel();
        }
      },
      modeTitle: config.modeIndicator.title
    }), ((_config$modeIndicator2 = config.modeIndicator) === null || _config$modeIndicator2 === void 0 ? void 0 : _config$modeIndicator2.ConfirmModal) && showConfirmModal && /*#__PURE__*/_jsx(config.modeIndicator.ConfirmModal, Object.assign({}, props.viewData, {
      onClose: props.onCancel
    })), config.ContentComponent ? /*#__PURE__*/_jsx(config.ContentComponent, {
      canvasScrollElementRef: canvasScrollElementRef,
      Canvas: InternalCanvasComponent,
      viewData: props.viewData,
      flow: props.flow,
      onCancel: props.onCancel
    }) : /*#__PURE__*/_jsx(InternalCanvasComponent, {
      flow: props.flow,
      onCancel: props.onCancel
    })]
  });
};
const ConnectedFlowView = compose(wireAuthConsumer, withRouter, LazyLangLoaderDecorator([actionFeaturesTranslations]))(FlowViewCanvas);
export default ConnectedFlowView;